import { useEffect, useState } from "react";
import { isContrastApproved } from "../A11yInspector/ContrastCalculator";

export const useContrastApproved = (color1, color2, ratio = 4.5) => {
    const [isApproved, setIsApproved] = useState(() => isContrastApproved(color1, color2, { minRatio: ratio }));

    useEffect(() => {
        setIsApproved(isContrastApproved(color1, color2, { minRatio: ratio }));
    }, [color1, color2, ratio]);

    return isApproved;
};
